import { BRANDS_ADD, SAVE_CURRENT_CARD_BRAND } from '../constants/actionTypes';

const INITIAL_STATE = {
  brands: [],
  currentBrand: '',
};

const applyAddBrands = (state, action) => ({
  ...state,
  brands: action.payload,
});

const applySaveCurrentCardBrand = (state, action) => ({
  ...state,
  currentBrand: action.payload,
});

const brandReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BRANDS_ADD:
      return applyAddBrands(state, action);
    case SAVE_CURRENT_CARD_BRAND:
      return applySaveCurrentCardBrand(state, action);
    default:
      return state;
  }
};

export default brandReducer;
